import React from 'react'
import styles from './image-flow.module.css'

const ImageFlow = ({ images, wide }) => {
return (
    <div className={`${styles.imageFlow} ${wide ? styles.wide : ''}`}>
        {images.map((image, index) => (
            <React.Fragment key={index}>
                <div className={styles.imageContainer}>
                    <img src={image.src} alt={image.alt || ''} />
                    {image.title && <h4 className="h4">{image.title}</h4>}
                    {image.body && <p className="body">{image.body}</p>}
                </div>
                {index < images.length - 1 && (
                    <svg className={styles.arrow} width="41" height="15" viewBox="0 0 41 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M40.3105 8.07039C40.7011 7.67986 40.7011 7.0467 40.3105 6.65617L33.9466 0.292213C33.5561 -0.0983109 32.9229 -0.0983109 32.5324 0.292213C32.1418 0.682738 32.1418 1.3159 32.5324 1.70643L38.1892 7.36328L32.5324 13.0201C32.1418 13.4107 32.1418 14.0438 32.5324 14.4343C32.9229 14.8249 33.5561 14.8249 33.9466 14.4343L40.3105 8.07039ZM0 7.36328V8.36328H39.6034V7.36328V6.36328H0V7.36328Z" fill="#21211E"/>
                    </svg>
                )}
            </React.Fragment>
        ))}
    </div>
)
}

export default ImageFlow
